import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endpoints from "../../endpoint";

// ✅ Apply Coupon (User/Partner)
export const applyCoupon = createAsyncThunk(
  "coupon/applyCoupon",
  async ({ couponCode, userId, cartTotal }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${endpoints.serverBaseUrl}api/coupon/apply`,
        { userId, couponCode, cartTotal },
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to apply coupon");
    }
  }
);

// ✅ Generate Coupon (Admin)
export const generateCoupon = createAsyncThunk(
  "coupon/generateCoupon",
  async (
    {
      code,
      discountType,
      discountValue,
      validTill,
      minPurchase,
      assignedTo,
      usageLimit,
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.post(
        `${endpoints.serverBaseUrl}api/coupon/create`,
        {
          code,
          discountType,
          discountValue,
          validTill,
          minPurchase,
          assignedTo,
          usageLimit,
        },
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to generate coupon"
      );
    }
  }
);

const couponSlice = createSlice({
  name: "coupon",
  initialState: {
    loading: false,
    error: null,
    appliedCoupon: null,
    generatedCoupon: null,
  },
  reducers: {
    clearCouponState: (state) => {
      state.appliedCoupon = null;
      state.generatedCoupon = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(applyCoupon.pending, (state) => {
        state.loading = true;
      })
      .addCase(applyCoupon.fulfilled, (state, action) => {
        state.loading = false;
        state.appliedCoupon = action.payload;
      })
      .addCase(applyCoupon.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(generateCoupon.pending, (state) => {
        state.loading = true;
      })
      .addCase(generateCoupon.fulfilled, (state, action) => {
        state.loading = false;
        state.generatedCoupon = action.payload;
      })
      .addCase(generateCoupon.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearCouponState } = couponSlice.actions;
export default couponSlice.reducer;
